import { ArrowRight } from "lucide-react";
import { FadeUp, MaskLines } from "./Reveal";

export default function CtaSection({ onBookCall }) {
  return (
    <section id="contact" className="scroll-mt-20 bg-ink pb-36 pt-28 md:pb-44 md:pt-40">
      <div className="mx-auto max-w-[1160px] px-6">
        <MaskLines
          lines={["Have a process", "that should run", "itself? Let’s build it."]}
          className="text-[clamp(2.6rem,5vw,4.4rem)] font-normal leading-[1.04] tracking-[-0.025em] text-white"
        />
        <FadeUp delay={0.15} className="mt-12 flex flex-wrap items-center gap-4">
          <button
            onClick={onBookCall}
            data-testid="book-a-call-btn"
            className="rounded-[10px] bg-brand px-6 py-3.5 text-[15px] font-medium text-white transition-all duration-300 hover:bg-brand-deep"
          >
            Book a call
          </button>
          <a
            href="https://wa.me/918921552108"
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-us-btn"
            className="group inline-flex items-center gap-2 rounded-[10px] border border-white/25 px-6 py-3.5 text-[15px] font-medium text-white transition-colors duration-300 hover:border-white/55"
          >
            WhatsApp us
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </FadeUp>
      </div>
    </section>
  );
}
